import { useEffect } from 'react'

import { isFunction } from '@/utils/helpers/typeChecking'

const useEventListener = ({ eventName, eventHandle, element = window }) => {
  useEffect(() => {
    // Resolve whether we got a ref object or a direct DOM element
    const target = element && 'current' in element ? element.current : element

    if (!target || !target.addEventListener) return

    if (eventName && isFunction(eventHandle)) {
      target?.addEventListener(eventName, eventHandle)

      return () => {
        target?.removeEventListener(eventName, eventHandle)
      }
    }
  }, [eventName, eventHandle, element])
}

export default useEventListener
